
import React from 'react';
import BaseModalComponent from './BaseModal';
//to use history.push
import { withRouter } from 'react-router-dom';

class Access extends BaseModalComponent {
  constructor(props) {
    super(props, props.subModuleName, props.Id, props.ParentComponent);
  }
  componentDidUpdate() {
    super.componentDidUpdate();
  }
  getAccessTitle(_t){
    var s = _t.CivilicaAccessType === 0 ? "دسترسی اعتباری به مقالات داخلی" : "دسترسی سالانه به مقالات داخلی";
    if (_t.isi_access_type !== '' && _t.isi_access_type !== null)
    {
      if (s !== '') s += " و ";
      s += "دسترسی اعتباری به مقالات بین اللملی";
    }
    return s;
  }
  saveForm(op='') {
    this.lockScreen();
    let type = "add";
    if (this.state.id_to_edit == 0)
      type = "add";
    else
      type = "edit";

    fetch(this.state.get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": type,
        "form": this.state.form_data.record,
        //این بخش در بعضی جاها نیاز هست
        "medias":this.state.form_data.medias
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((resualt) => {
      this.unLockScreen();
      if (resualt.status == 1) {
        this.showToast('اطلاعات با موفقیت ذخیره شد.','success');
        if (this.state.form_data.record.type === 1)
          this.go('/accounts/mobiles/');
        if (this.state.form_data.record.type === 2)
          this.go('/accounts/emails/');
      }
      else
      {
        if (resualt.message === undefined)
        this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
        else
        this.showToast(resualt.message,'warning');
      }
    })
    //.catch(err=>{
    //  this.unLockScreen();
    //  this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
    //});
  }
  renderBody() {
    return (<div className="row">
    <h4 className="alert alert-info text-center">بعد از هر بار ثبت / ویرایش این اطلاعات بایستی منتظر تایید از سمت مدیریت سامانه باشید</h4>
      <div className="col-md-12">
          <div className="box box-info">
            <div className="form-horizontal">
              <div className="box-body">
                <div className="form-group">
                  {this.state.form_data.record.type === 1 ?
                    <label className="col-sm-12 control-label">شماره موبایل</label>
                  :
                    <label className="col-sm-12 control-label">آدرس دامین ایمیل (بدون درج @)</label>
                  }
                  <div className="col-sm-6">
                    <input type="text" className="form-control" onChange={(e) => { this.setFormValue(e, "value") }} defaultValue={this.state.form_data.record.value} />
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-sm-12 control-label">حساب</label>
                  <div className="col-sm-6">
                    <select className="form-control" onChange={(e) => { this.setFormValue(e, "legal_account_id") }} defaultValue={this.state.form_data.record.legal_account_id}>
                      <option>حسابی که میخواهید این دسترسی بر روی آن اعمال شود را انتخاب نمایید</option>
                      {this.state.form_data.legalAccounts.map(_t=>
                        <option value={_t.id}>{this.getAccessTitle(_t)}</option>
                      )}
                    </select>
                  </div>
                </div>
              </div>
            </div>
    
          <div className="form-horizontal text-center" style={{"padding":"40px"}}>
            <button type="button" className="btn btn-success" onClick={(e) => { this.saveForm('return'); }} style={{ "marginLeft": "5px" }}>ارسال</button>
          </div>
        </div>

      </div>
    </div>
    );
  }
  render() {
    if (this.state.form_data === null || this.state.form_data === undefined)
      return this.showLoading();
    if (this.state.form_data.status === 500 || this.state.form_data.status === 0)
      return this.render500();
    if (this.state.form_data.status === 404)
      return this.render404();
    if (this.state.form_data.status === 2)
      return this.renderNoAccess();
    if (this.state.form_data.status === 4)
      return this.renderNoLogin();
    return this.renderBody();
  }
}
const AccessEXP = withRouter(Access);
export default AccessEXP;